import ConfigManager from "./ConfigManager";
import Logger from "./Logger";
import pbjs from "./pbjs";

class PrebidManager {
  processedAdUnits: boolean = false;

  do(func) {
    pbjs().que.push(func);
  }

  setupAdUnits() {
    if (this.processedAdUnits) return;
    this.processedAdUnits = true;
    const adUnits = ConfigManager.getPrebidAdUnitsConfig();

    Logger.log("Adding adUnits to prebid", adUnits);
    this.do(() => {
      pbjs().setConfig({ debug: true });
      pbjs().addAdUnits(adUnits);
      Logger.log("prebid adunits added");
    });
  }

  configure() {
    this.do(() => {
      this.setupBucketSizing();
    });
  }

  setupBucketSizing() {
    const customConfigObject = {
      buckets: [
        {
          max: 20,
          increment: 0.05, // $0.05 - $20 increments of $0.05
        },
        {
          max: 50,
          increment: 1, // $20-$50 increments of $1
        },
      ],
    };
    Logger.log("Setting bucket sizing to", customConfigObject);
    //set custom config object
    pbjs().setConfig({
      priceGranularity: customConfigObject,
    });
  }
}

export default new PrebidManager();
